import { decodeId } from 'utils';

/**
 * Owning organization of a product (experience or hotel), normalized to a
 * comparable string. Organization ids may arrive raw or gid-encoded depending
 * on the endpoint, so both sides are decoded before comparison.
 */
const productOwnerId = (product) =>
  product?.organizationId != null
    ? String(decodeId(product.organizationId))
    : null;

/**
 * Whether two organization ids designate the same organization.
 *
 * The same organization is identified by three different shapes across our
 * APIs: a number (the user's `organizationId`), a numeric string (the node
 * API, where ids are `int8` columns serialized as strings) and a gid-encoded
 * string (the graph API). A raw `===` between two of these is never true, so
 * both sides go through `decodeId` first.
 */
export const isSameOrganization = (organizationId, otherOrganizationId) =>
  organizationId != null &&
  otherOrganizationId != null &&
  String(decodeId(organizationId)) === String(decodeId(otherOrganizationId));

/**
 * Whether a product (experience or hotel) belongs to the given organization.
 * Products without a resolvable owner (external inventory, search results
 * without ownership data) are treated as own. Used to gate what the DMC may
 * open in detail: partner products are not consultable outside the trip.
 */
export const isOwnProduct = (product, currentOrganizationId) =>
  productOwnerId(product) == null ||
  currentOrganizationId == null ||
  isSameOrganization(productOwnerId(product), currentOrganizationId);
